import React, { useEffect, useState } from 'react'
import { Button } from '@arnsbogroup/react-voicearchive'

const LOCALES = [
  'en',
  'da-DK',
  'de-DE',
]

const SupplierProfile = ({ match: { params: { supplierId } } }) => {
  const [descriptions, setDescriptions] = useState([])
  const [descriptionChanges, setDescriptionChanges] = useState({})

  useEffect(() => {
    fetch(`/rest/v2/supplier/${supplierId}/descriptions`)
      .then(response => response.json())
      .then(data => {
        setDescriptions(data)
      });

  }, [])

  const onChangeHandler = (iso, description) => {
    setDescriptionChanges(d => ({ ...d, [iso]: description }))
  }

  const onSaveHandler = (iso) => {
    fetch(`/rest/v2/supplier/${supplierId}/descriptions/${iso}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        description: descriptionChanges[iso],
      })
    }).then(response => {
      setDescriptionChanges(d => {
        const { [iso]: _, ...rest } = d
        return rest
      })
      if (response.ok) {
        toastr.success('Changes in description was saved')
      } else {
        response.json().then(data => {
          toastr.error(data.errors.join(', '), 'Changes was not saved successfully!')
        })
      }
    })
  }

  const onAdd = (iso) => {
    setDescriptions(d => [...d, { iso, description: '' }])
  }

  return (
    <div>
      <div className="p-4">
        The profile description will be visible on the voice talents website/VoiceFinder profile (i.e. <a className="text-primary" href="https://www.voicearchive.com/en/voicefinder/search/DUTF3527-PAULINE" target="_blank">https://www.voicearchive.com/en/voicefinder/search/DUTF3527-PAULINE</a>). It is optional, and no default placeholder text will be included if descriptions are not present. Profile descriptions can be added for all locales all at once, but you are also allowed to only define a description for a specific locale.
      </div>
      <div className="border border-yellow-400 bg-yellow-200 m-4 p-4 flex justify-center items-center">
        <div className="">These profile descriptions are <b>public visible</b> on our websites. Please make sure to only include information, approved to be shown to the public and our website visitors.</div>
      </div>

      <div className={`grid grid-cols-3`}>
        { LOCALES.map((iso) => {
          const description = descriptions.find(d => d.iso === iso)

          return description ? (
            <div key={iso} className="p-3">
              <div className="uppercase text-gray-700 font-medium my-4">{ description.iso }</div>
              <textarea
                className="w-full h-64 p-4"
                value={descriptionChanges[iso] ?? description.description}
                placeholder={`No description yet for ${iso.toUpperCase()}`}
                onChange={({ target: { value } }) => {
                  onChangeHandler(iso, value)
                }}
              />
              { descriptionChanges[iso] && (
                <Button
                  size="sm"
                  onClick={() => onSaveHandler(iso)}
                >
                  Save Changes
                </Button>
              )}
            </div>
          ) : (
            <div key={iso} className="p-3">
              <div className="uppercase text-gray-700 font-medium my-4">{ iso }</div>
              <div className="w-full h-64 p-4 text-gray-600 border border-gray-300 mt-4">
                No description yet for { iso.toUpperCase() }. <a href="#" className="text-primary font-bold" onClick={() => onAdd(iso)}>Add</a> description for { iso.toUpperCase() }.
              </div>
            </div>
          )
        }) }
      </div>
    </div>
  )
}

export default SupplierProfile
